module.exports = __webpack_public_path__ + "img/yun.de6b5afc.png";